import { IState } from 'legacy/lut/store'

export const selectFinSobState = (state: IState) => state.partner360.finSob
